export const isVariantPackage = (course) => course?.type === "variant";

export const isPackagePurchased = (course) => {
  if (!course) return false;

  const subscribed = course.is_subscribe;
  if (subscribed === true || subscribed === 1 || subscribed === "1") {
    return true;
  }

  const tag = String(course.thumbnail_tag || "").trim().toUpperCase();
  return tag === "PURCHASED";
};

export const isVariantOptionPurchased = (variant) => {
  if (!variant) return false;

  const subscribed = variant.is_subscribe;
  return subscribed === true || subscribed === 1 || subscribed === "1";
};

export const shouldOpenVariantModal = (course) =>
  isVariantPackage(course) && Boolean(course?.package_id);

export const shouldShowBuyNow = (course) => !isPackagePurchased(course);
